import React from 'react';

const PrediccionesFantasyIcon = ({ width = 24, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
            <path
                fill="#D8BA66"
                d="M390.289 429.373c-14.648-28.059-52.089-77.269-134.547-77.269l-4.173 32.523l-4.173-32.523c-82.458 0-119.899 49.21-134.547 77.269c-5.219 5.959-8.063 12.356-8.063 19.017c0 32.069 65.717 58.066 146.783 58.066s146.783-25.997 146.783-58.066c0-6.661-2.844-13.059-8.063-19.017"
            />
            <circle cx="246.726" cy="220.228" r="213.282" fill="#725FAF" />
            <path
                fill="#9180D6"
                d="M451.466 160.323C425.577 71.695 343.718 6.946 246.726 6.946a214.3 214.3 0 0 0-41.286 4.008c-54.97 32.524-85.762 94.647-78.769 157.791c1.369 12.362-5.962 23.913-17.694 28.042l-.22.078c-36.338 12.887-60.246 45.147-64.241 81.055a22 22 0 0 1-1.462 5.801c18.915 60.741 64.26 109.82 122.573 133.814A108 108 0 0 0 161 402.077c-3.265-8.522 1.234-17.937 9.926-20.718a100 100 0 0 0 2.91-.981c24.41-8.657 43.211-26.057 54.135-47.432c7.375-14.43 23.02-22.745 39.083-20.597c35.831 4.791 74.037-2.289 108.963-23.95c44.99-27.903 72.95-76.173 75.449-128.076"
            />
            <circle cx="212.74" cy="193.6" r="15.414" fill="#9180D6" />
            <path
                fill="#725FAF"
                d="M413.766 111.027c0 8.513-6.901 15.414-15.414 15.414s-15.414-6.901-15.414-15.414s6.901-15.414 15.414-15.414s15.414 6.901 15.414 15.414m-26.953 81.199c-15.465 0-28.002 12.537-28.002 28.002s12.537 28.002 28.002 28.002s28.002-12.537 28.002-28.002s-12.538-28.002-28.002-28.002M225.01 237.994c-11.121 0-20.136 9.015-20.136 20.136s9.015 20.136 20.136 20.136s20.136-9.015 20.136-20.136s-9.016-20.136-20.136-20.136"
            />
            <circle cx="200.47" cy="99.084" r="8.467" fill="#D1CFC3" />
            <path
                fill="#C4A6FF"
                d="M154.227 294.784c0 11.121-9.015 20.136-20.136 20.136s-20.136-9.015-20.136-20.136s9.015-20.136 20.136-20.136s20.136 9.016 20.136 20.136m-7.865-91.323a8.467 8.467 0 1 0 0 16.934a8.467 8.467 0 0 0 0-16.934m147.829 8.468a8.467 8.467 0 1 0 0 16.934a8.467 8.467 0 0 0 0-16.934m-19.91 149.438c-8.946 0-16.199 7.253-16.199 16.199s7.253 16.199 16.199 16.199s16.199-7.253 16.199-16.199s-7.253-16.199-16.199-16.199"
            />
            <path
                fill="#DFD2FF"
                d="M323.028 107.615c0 15.926-12.911 28.837-28.837 28.837s-28.837-12.911-28.837-28.837s12.911-28.837 28.837-28.837s28.837 12.911 28.837 28.837m-1.153 216.935a7.117 7.117 0 0 0-7.117 7.117c0 3.931 3.186 7.117 7.117 7.117s7.117-3.186 7.117-7.117a7.117 7.117 0 0 0-7.117-7.117"
            />
            <path
                fill="#8280D8"
                d="M65.01 117.532a15.3 15.3 0 0 0-1.481-6.56a213 213 0 0 0-11.359 21.742c7.285-1.227 12.84-7.548 12.84-15.182"
            />
            <path
                fill="#9180D6"
                d="M404.772 363.442c-4.86-8.299-13.863-13.877-24.175-13.877c-15.465 0-28.002 12.537-28.002 28.002c0 8.702 3.97 16.477 10.197 21.613a214.4 214.4 0 0 0 41.98-35.738"
            />
        </svg>
    );
};

export default PrediccionesFantasyIcon;
